<template>
  <section class="my-tickets">
    <div class="container" v-show="!QRVisible">
      <h2 class="page-title">Moje bilety</h2>
      <div class="tickets-list">
        <div class="header">
          <div class="train-category column-first"></div>
          <div class="travel-stations column-long">
            <span class="single">Relacja</span>
          </div>
          <div class="departure-time column-short">
            <span class="single">Data i czas wyjazdu</span>
          </div>
          <div class="purchase-time column-short">
            <span class="single">Data i czas zakupu</span>
          </div>
          <div class="actions column-last">
            <span class="single">Akcje</span>
          </div>
        </div>
        <div class="body">
          <div class="ticket" v-for="ticket in myTickets" :key="ticket.id">
            <div class="train-category column-first">
              <TrainCategory
                :selectable="false"
                :category="getTrainCategory(ticket.trainCategoryID)"
              />
            </div>
            <div class="travel-stations column-long">
              <span class="single">{{ getTravelStations(ticket) }}</span>
            </div>
            <div class="departure-time column-short">
              <span class="multi">{{ getDate(ticket.departureTime) }}</span>
              <span class="multi">{{ getTime(ticket.departureTime) }}</span>
            </div>
            <div class="purchase-time column-short">
              <span class="multi">{{ getDate(ticket.purchaseTime) }}</span>
              <span class="multi">{{ getTime(ticket.purchaseTime) }}</span>
            </div>
            <div class="actions column-last">
              <button
                type="button"
                class="show-qr-button"
                title="Wyświetl kod QR biletu"
                @click="showTicketQR(ticket)"
              >
                <i class="fas fa-qrcode"></i>Pokaż QR
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TicketQR
      v-if="QRVisible"
      :QRData="QRData.QR"
      :ticketData="QRData.ticketData"
      @backToTickets="closeTicketQR"
    />
  </section>
</template>


<script>
import { isNull } from 'util';

import TrainCategory from '../controls/TrainCategory.vue';
import TicketQR from '../components/TicketQR.vue';

import storeMixins from '../mixins/storeMixins';
import findMixins from '../mixins/findMixins';

import moment from '../helpers/moment';
import updatePageTitle from '../helpers/updatePageTitle';

export default {
  name: 'MyTickets',
  components: {
    TrainCategory,
    TicketQR,
  },
  mixins: [storeMixins, findMixins],
  data() {
    return {
      QRData: {
        ticketData: null,
        QR: null,
      },
    };
  },
  computed: {
    QRVisible() {
      return !isNull(this.QRData.QR);
    },
  },
  created() {
    this.$store.dispatch('myTickets/fetchFromServer', this.userToken);
    updatePageTitle('Moje bilety');
  },
  mounted() {
    // przemiń do góry
    this.$scrollTo(document.body);
  },
  beforeRouteEnter(to, from, next) {
    // przekieruj na stronę logowania, jeśli brak uprawnień
    next((vm) => {
      if (!vm.userSignedIn) {
        vm.$router.push({ name: 'SignPage' });
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    // odśwież listę biletów
    this.$store.dispatch('myTickets/fetchFromServer', this.userToken);
    updatePageTitle('Moje bilety');

    next();
  },
  methods: {
    getTravelStations(ticket) {
      return `${this.getStationById(ticket.stationFromID).displayName} - ${
        this.getStationById(ticket.stationToID).displayName
      }`;
    },
    getDate(value) {
      return moment(value).format('DD.MM.YYYY');
    },
    getTime(value) {
      return moment(value).format('HH:mm');
    },
    showTicketQR(ticket) {
      this.$store
        .dispatch('myTickets/fetchTicketQR', ticket.id)
        .then((response) => {
          this.QRData.ticketData = ticket;
          this.QRData.QR = response.data;
        });
    },
    closeTicketQR() {
      this.QRData.ticketData = null;
      this.QRData.QR = null;
    },
  },
};
</script>

<style scoped>
.my-tickets {
  min-height: 500px;
  padding-bottom: 100px;
}

.tickets-list .header {
  display: flex;
  flex-flow: row nowrap;
  background-color: rgba(63, 81, 181, 0.1);
  padding: 5px 0;
  border-bottom: 2px solid var(--color-main);
}

.tickets-list .header div {
  font-size: 20px;
}

.tickets-list .header > div,
.tickets-list .body .ticket > div {
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}

.tickets-list .column-first {
  width: 9%;
}

.tickets-list .column-long {
  width: 31%;
}

.tickets-list .column-short {
  width: 20%;
}

.tickets-list .column-last {
  width: 20%;
}

.tickets-list .body .ticket {
  display: flex;
  flex-flow: row nowrap;
  cursor: default;
}

.tickets-list .body .ticket > div {
  padding: 12px 0;
}

.tickets-list .body .ticket:hover {
  background-color: #eee;
}

.tickets-list .body .train-category {
  flex-flow: row nowrap !important;
  justify-content: left !important;
}

.tickets-list .body .train-category a {
  margin-left: 10px;
}

.tickets-list .body .travel-stations {
  font-size: 20px;
}

.tickets-list .body .departure-time,
.tickets-list .body .purchase-time {
  font-size: 15px;
  line-height: 20px;
}
</style>
